import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import styled from "styled-components";
import ShowDataRows from "../../../Components/SmallComponent/ShowDataRows";

function TicketLead({ ticketValue }) {
    // console.log(ticketValue);
    return (
        <LeadContainer>
            <Box>
                {/* <ShowDataRows data={ticketValue?.lead} /> */}
                <Grid container spacing={2}>
                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Cutomer Type:
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.customer_type}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                First Name:
                            </Typography>

                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.first_name}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Last Name:
                            </Typography>

                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.last_name}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Phone :
                            </Typography>

                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.phone}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Mobile :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.mobile}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                is phone receives txt :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.is_phone_receives_txt === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Email :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.email}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                preferred language :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.preferred_language}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Street :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.street}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Zip Code :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.zip_code}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                status :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.status}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Building type :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.building_type}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                way to contact :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.way_to_contact}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Is decision maker present :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.is_decision_maker_present}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                House ownership :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead?.house_ownership}
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item mt={1} md={4} sm={6}>
                        <Typography variant="span">
                            <Typography variant="span" mr={3} className="title">
                                Is decision maker present :
                            </Typography>
                            <Typography variant="span" className="text-gray">
                                {ticketValue?.lead
                                    ?.is_decision_maker_present === 1
                                    ? "True"
                                    : "False"}
                            </Typography>
                        </Typography>
                    </Grid>
                    {ticketValue?.opportunity?.aerial_photo && (
                        <Grid item xs={12} mt={2}>
                            <img
                                className="solution-image"
                                src={ticketValue?.opportunity?.aerial_photo}
                                alt="file"
                            />
                        </Grid>
                    )}
                </Grid>
            </Box>
        </LeadContainer>
    );
}

const LeadContainer = styled.div`
    .solution-image {
        width: 100%;
        border-radius: 20px;
        max-height: 100vh;
    }
`;

export default TicketLead;
